import { render, staticRenderFns } from "./popup-do-mu-ban.vue?vue&type=template&id=809a816e&scoped=true"
import script from "./popup-do-mu-ban.vue?vue&type=script&lang=js"
export * from "./popup-do-mu-ban.vue?vue&type=script&lang=js"
import style0 from "./popup-do-mu-ban.vue?vue&type=style&index=0&id=809a816e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "809a816e",
  null
  
)

export default component.exports